import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getStudyPlansListAction, StudyPlansListParams } from '../actions';

const {
  useLoaderData: useStudyPlansListLoaderData,
  LoaderConsumerSimple: StudyPlansListLoaderConsumer,
  LoaderProvider: StudyPlansListLoaderProvider,
  useLoader: useStudyPlansListLoader,
} = createLoaderImp({
  action: getStudyPlansListAction,
});

export {
  StudyPlansListLoaderProvider,
  StudyPlansListLoaderConsumer,
  useStudyPlansListLoaderData,
  useStudyPlansListLoader,
};

export type { StudyPlansListParams };
